module.exports = __webpack_public_path__ + "static/media/sample17.b7b30117.jpg";